import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tooltip-wrapper" }

import { ref } from "vue";

interface Props {
  location: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    location: { default: "bottom" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "toggle"),
    _createElementVNode("div", {
      class: _normalizeClass(["custom-tooltip", `${__props.location}`])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _cache[0] || (_cache[0] = _createTextVNode(" Shalom from the tooltip! ", -1))
      ])
    ], 2)
  ]))
}
}

})